const getEmphasis = (color: string) => {
  return {
    itemStyle: {
      color,
      opacity: 0.9,
    },
    disabled: false,
    focus: "series",
  };
};

export default getEmphasis;
